import { PaymentProduct } from '~shared/api/client';

export const AUTO_FARMING_LIFE_TIME_MAP = {
  [PaymentProduct.AUTO_FARMING_3DAYS]: 60 * 60 * 24 * 3,
  [PaymentProduct.AUTO_FARMING_9DAYS]: 60 * 60 * 24 * 9,
  [PaymentProduct.AUTO_FARMING_30DAYS]: 60 * 60 * 24 * 30,
} as const;
